/**
* @param {string} u 后台的谷歌统计id  后台字段：GAUA
*/
export function GTAG (u) {
 // 创建 script 标签
 let script = document.createElement('script')
 // 在script标签中追加 src 属性
 script.src = `https://www.googletagmanager.com/gtag/js?id=${u}`
 // 返回一个包括所有给定标签名称的元素的HTML集合HTMLCollection。 整个文件结构都会被搜索，包括根节点
 // 相当于 firstScript是返回所有节点的第一个节点
 let firstScript = document.getElementsByTagName('script')[0]
 // 将script标签的async = true
 // async：对于普通脚本，如果存在 async 属性，那么普通脚本会被并行请求，并尽快解析和执行。
 script.async = true
 // parentNode 新插入节点的父节点
 // insertBefore() 方法在参考节点之前插入一个拥有指定父节点的子节点
 firstScript.parentNode.insertBefore(script, firstScript)
 window.dataLayer = window.dataLayer || []
 function gtag () {
   window.dataLayer.push(arguments)
 }
 gtag('js', new Date())
 gtag('config', `${u}`)
}

export function getQueryString (link, key) {
  const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
  const queryString = link.split('?').length > 1 ? link.split('?')[1] : ''
  const r = queryString.match(reg)
  if (r !== null) return decodeURIComponent(r[2])
  return ''
}

export function isMobile () {
  const ua = navigator.userAgent.toLowerCase()
  return /iphone|android|ucweb|ucbrowser|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(ua) && !/ipad/i.test(ua) || document.body.clientWidth <= 768
}
